<template>
  <div class="sf-faq-page">
    <!-- faq search section -->
    <section class="sf-faq-hero">
      <div class="sf-faq-hero-glow" />
      <h2 class="sf-faq-hero-title">
        Vamos responder as perguntas mais frequentes
      </h2>
      <p class="sf-faq-hero-subtitle">
        ou escolha uma categoria para ver as perguntas
      </p>
      <div class="sf-faq-search">
        <feather-icon
          icon="SearchIcon"
          class="sf-faq-search-icon"
        />
        <input
          id="searchbar"
          v-model="faqSearchQuery"
          class="sf-faq-search-input"
          placeholder="Procurar no faq ..."
        >
      </div>
    </section>
    <!--/ faq search section -->

    <!-- frequently asked questions tabs pills -->
    <section class="sf-faq-body">
      <b-tabs
        v-model="tabIndexCategory"
        nav-wrapper-class="sf-faq-nav-wrapper col-md-4 col-lg-3 col-12"
        nav-class="sf-faq-nav"
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
      >

        <!-- payment tab -->
        <b-tab
          v-for="(categoryObj, categoryName) in faqData"
          :key="categoryName"
        >

          <!-- title -->
          <template #title>
            <feather-icon
              size="18"
              class="mr-1"
              :icon="categoryObj.icon"
            />
            <router-link
              tag="span"
              class="font-weight-bold"
              :to="'/spot/faq/'+sanitizeTitle(categoryObj.titulo)"
            >
              {{ categoryObj.titulo }}
            </router-link>
          </template>

          <faq-category :options="categoryObj" />
        </b-tab>
        <!--/ payment tab -->
      </b-tabs>
    </section>
    <!--/ frequently asked questions tabs pills -->

  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import store from '@/store'
import utilsMixin from '@/mixins/utilsMixin'
import FaqCategory from './FaqCategory.vue'
import faqStoreModule from './faqStoreModule'

const FAQ_SPOT_STORE_MODULE_NAME = 'faq-spot'

export default {
  components: {
    BTabs,
    BTab,
    FaqCategory,
  },

  mixins: [utilsMixin],

  data() {
    return {
      faqSearchQuery: '',
      faqDataOrigem: {},
      faqData: {},
      tabIndexCategory: 0,
    }
  },

  watch: {
    faqSearchQuery: {
      immediate: true,
      handler() {
        this.filterData()
      },
    },
  },

  created() {
    if (!store.hasModule(FAQ_SPOT_STORE_MODULE_NAME)) store.registerModule(FAQ_SPOT_STORE_MODULE_NAME, faqStoreModule)
    this.fetchData()
  },

  beforeDestroy() {
    if (store.hasModule(FAQ_SPOT_STORE_MODULE_NAME)) store.unregisterModule(FAQ_SPOT_STORE_MODULE_NAME)
  },

  mounted() {
    if (this.$route.params.slugQuest) {
      this.scrollToElement(this.$el.getElementsByClassName(`quest-${this.$route.params.slugQuest}`)[0])
    }
  },

  methods: {

    filterData() {
      const filteredData = {}
      const queryLowered = this.faqSearchQuery.toLowerCase()
      Object.entries(this.faqDataOrigem).forEach(entry => {
        const [categoryName, categoryObj] = entry
        // eslint-disable-next-line arrow-body-style
        const filteredQAndAOfCategory = categoryObj.qandA.filter(qAndAObj => {
          return qAndAObj.question.toLowerCase().includes(queryLowered)
        })
        if (filteredQAndAOfCategory.length) {
          filteredData[categoryName] = { ...categoryObj, qandA: filteredQAndAOfCategory }
        }
      })
      this.faqData = filteredData
    },

    fetchData() {
      store
        .dispatch('faq-spot/getFaqCategorys')
        .then(response => {
          this.faqDataOrigem = response.data
          this.faqData = response.data
          this.tabIndexCategory = Object.entries(this.faqDataOrigem).findIndex(tab => this.sanitizeTitle(tab[1].titulo) === this.$route.params.slugCategory)
        })
    },

  },
}
</script>

<style lang="scss" scoped>
/* ============================================================
   FAQ — hero de busca + tabs verticais — padrão Soulf.
   ============================================================ */
.sf-faq-page { position: relative; }

.sf-faq-hero {
  position: relative;
  overflow: hidden;
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 20px;
  padding: 48px 24px;
  text-align: center;
  margin-bottom: 32px;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
  }
}
.sf-faq-hero-glow {
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 320px;
  height: 180px;
  background: rgba(59, 130, 246, 0.25);
  filter: blur(90px);
  pointer-events: none;
}
.sf-faq-hero-title {
  position: relative;
  font-family: 'Geist', sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 8px;
}
.sf-faq-hero-subtitle {
  position: relative;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  margin: 0 0 24px;
}
.sf-faq-search {
  position: relative;
  max-width: 460px;
  margin: 0 auto;
}
.sf-faq-search-icon {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.40);
  pointer-events: none;
}
.sf-faq-search-input {
  width: 100%;
  background: #000;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 9999px;
  padding: 12px 18px 12px 42px;
  color: #fff;
  font-family: 'Geist', sans-serif;
  font-size: 13.5px;

  &::placeholder { color: rgba(255, 255, 255, 0.35); }
  &:focus {
    outline: none;
    border-color: rgba(59, 130, 246, 0.45);
    background: #0F0F11;
  }
}

.sf-faq-body { position: relative; }

::v-deep .sf-faq-nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: transparent;
  padding: 0;
  border: none;

  .nav-item { margin: 0; }

  .nav-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-radius: 12px;
    color: rgba(255, 255, 255, 0.65);
    font-family: 'Geist', sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    background: transparent !important;
    transition: background-color .15s ease, color .15s ease;

    &:hover { background: rgba(255, 255, 255, 0.05) !important; color: #fff; }

    &.active {
      background: rgba(59, 130, 246, 0.12) !important;
      color: #fff !important;
      box-shadow: none !important;
    }
  }
}

::v-deep .tab-content { background: transparent; }
</style>
